export type UnderlayKind = 'image' | 'pdf'
export type UnderlayOrdering = 'behind-grid' | 'above-plan'

export type BackgroundUnderlay = {
  kind: UnderlayKind
  source: string
  name: string
  sourceWidthPx: number
  sourceHeightPx: number
  referencePixels: number
  referenceDistanceM: number
  originXMm: number
  originYMm: number
  rotationDeg: number
  opacity: number
  ordering: UnderlayOrdering
  crop: { xPx: number; yPx: number; widthPx: number; heightPx: number }
}

export function validateUnderlayCalibration(input: Pick<BackgroundUnderlay, 'source' | 'sourceWidthPx' | 'sourceHeightPx' | 'referencePixels' | 'referenceDistanceM' | 'opacity' | 'crop'>) {
  if (!input.source) throw new Error('Добавьте файл или URL подложки')
  if (!Number.isFinite(input.sourceWidthPx) || input.sourceWidthPx <= 0 || !Number.isFinite(input.sourceHeightPx) || input.sourceHeightPx <= 0) {
    throw new Error('Укажите положительные размеры исходника в пикселях')
  }
  if (!Number.isFinite(input.referencePixels) || input.referencePixels <= 0 || !Number.isFinite(input.referenceDistanceM) || input.referenceDistanceM <= 0) {
    throw new Error('Дистанция и её размер на изображении должны быть положительными')
  }
  if (!Number.isFinite(input.opacity) || input.opacity < 0 || input.opacity > 1) throw new Error('Прозрачность должна быть от 0 до 1')
  const { xPx, yPx, widthPx, heightPx } = input.crop
  if (xPx < 0 || yPx < 0 || widthPx <= 0 || heightPx <= 0 || xPx + widthPx > input.sourceWidthPx || yPx + heightPx > input.sourceHeightPx) {
    throw new Error('Обрезка выходит за границы исходника')
  }
}

export function calibrateUnderlay(input: Pick<BackgroundUnderlay, 'sourceWidthPx' | 'sourceHeightPx' | 'referencePixels' | 'referenceDistanceM'>) {
  if (input.referencePixels <= 0 || input.referenceDistanceM <= 0) throw new Error('Calibration values must be positive')
  const metresPerPixel = input.referenceDistanceM / input.referencePixels
  return {
    metresPerPixel,
    widthM: input.sourceWidthPx * metresPerPixel,
    heightM: input.sourceHeightPx * metresPerPixel,
    widthMm: Math.round(input.sourceWidthPx * metresPerPixel * 1000),
    heightMm: Math.round(input.sourceHeightPx * metresPerPixel * 1000),
  }
}

export function getUnderlayCrop(input: Pick<BackgroundUnderlay, 'sourceWidthPx' | 'sourceHeightPx' | 'crop'>) {
  const crop = input.crop.widthPx > 0 && input.crop.heightPx > 0
    ? input.crop
    : { xPx: 0, yPx: 0, widthPx: input.sourceWidthPx, heightPx: input.sourceHeightPx }
  return crop
}
